module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper",
    attrs: {
      "align": "center"
    }
  }, [_c('ContactUsHeader'), _vm._v(" "), _c('div', {
    staticClass: "block-center mt-xl wd-xl"
  }, [_c('div', {
    staticClass: "panel panel-dark panel-flat"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_vm._m(0), _vm._v(" "), _c('form', {
    staticClass: "mb-lg",
    attrs: {
      "role": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group has-feedback"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "password",
      "type": "password",
      "placeholder": "Your new password",
      "autocomplete": "off",
      "required": ""
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('em', {
    staticClass: "form-icon icon-lock"
  })]), _vm._v(" "), _c('PasswordHint', {
    attrs: {
      "password": _vm.password
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group has-feedback"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passwordConfirmation),
      expression: "passwordConfirmation"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "passwordConfirmation",
      "type": "password",
      "placeholder": "Confirm your new password",
      "autocomplete": "off",
      "required": ""
    },
    domProps: {
      "value": (_vm.passwordConfirmation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.passwordConfirmation = $event.target.value
      }
    }
  }), _vm._v(" "), _c('em', {
    staticClass: "form-icon icon-lock"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-block btn-default btn-lg mt-xl",
    attrs: {
      "type": "submit",
      "disabled": !_vm.canSubmit
    }
  }, [_vm._v("Change password")]), _vm._v(" "), _c('div', {
    staticClass: "form-group has-feedback",
    class: {
      'has-error': _vm.resetPasswordError
    }
  }, [_c('strong', {
    staticClass: "help-block",
    attrs: {
      "id": "helpBlock6"
    }
  }, [_vm._v(_vm._s(_vm.resetPasswordError))])])], 1)])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-center pv"
  }, [_c('strong', [_vm._v("Change Password")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38b7284d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChangePassword.vue
// module id = 2138
// module chunks = 1